import { useMemo } from "react";

import { GPDEndRegistrationTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GpdEndRegistrationFormProps } from "@/types/form-types";

import { useGpdUiSchema } from "../../schema/gpd-ui-schema";

import { getGpdEndRegistrationSchema } from "./schema/gld-closure-schema";

export function GpdEndRegistrationForm(props: GpdEndRegistrationFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<GPDEndRegistrationTask>({
    key: "gpdEndRegistration",
    task,
  });

  const uiSchema = useGpdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getGpdEndRegistrationSchema(type), [type]);

  const onSubmit = async () => {
    if (!formData) return;
    await api.createGpdEndRegistration(formData);
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
